export default { sha: '3a7bf64c1cad429ff1a69caf4159690de0a67e4a', buildNumber: 'undefined' }
